<script setup lang="ts">
import { PropType } from 'vue';
import { setup, type Props } from './skeletonLoading.setup';

const props = defineProps({
  randomMaxWidthPercent: {
    type: Number as PropType<Props['randomMaxWidthPercent']>,
    default: 70,
    validator: (
      value: number,
      { randomMinWidthPercent = 70 }: { randomMinWidthPercent: Props['randomMinWidthPercent'] },
    ) => value >= 0 && value <= 100 && value > randomMinWidthPercent,
  },
  randomMinWidthPercent: {
    type: Number as PropType<Props['randomMinWidthPercent']>,
    default: 30,
    validator: (
      value: number,
      { randomMaxWidthPercent = 30 }: { randomMaxWidthPercent: Props['randomMaxWidthPercent'] },
    ) => value >= 0 && value <= 100 && randomMaxWidthPercent > value,
  },
  width: {
    type: String as PropType<Props['width']>,
    default: null,
  },
  height: {
    type: String as PropType<Props['height']>,
    default: '1rem',
  },
});

const { boxWidth } = setup(props);
</script>

<template>
  <span
    class="skeleton"
    :style="{ height, width: boxWidth }"
  />
</template>
